import React, { useEffect, useState } from 'react';
import WmsSidebar from '../../components/WmsSidebar';
import WmsTopbar from '../../components/wms_topbar';
import { getWmsAlmacenes, getUbicaciones, createUbicacion } from '../../api.wms';
import { getWmsClientes } from '../../api.wms.clientes';
import { getWmsProductos } from '../../api.wms.productos';
import { createWmsOrden } from '../../api.wms';
import { Search, UploadCloud, FileSpreadsheet, Book, Plus } from 'lucide-react';
import * as XLSX from 'xlsx';
import { getWarehousesByUser } from '../../api.wms';
import { useAuth } from '../../contexts/AuthContext';
import { PDFDownloadLink } from '@react-pdf/renderer';
import OrdenSalidaPDF from '../../components/OrdenSalidaPDF';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

const WmsOrdenSalida = () => {
  const { userRole } = useAuth();
  const [activeItem, setActiveItem] = useState('ordenes');
  const [almacenes, setAlmacenes] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [productos, setProductos] = useState([]);
  const [ubicaciones, setUbicaciones] = useState([]); // Lista de ubicaciones disponibles
  const [clientesFinales, setClientesFinales] = useState([]); // Lista única de clientes
  const [direccionesCliente, setDireccionesCliente] = useState([]); // Direcciones del cliente seleccionado
  const [busquedaCliente, setBusquedaCliente] = useState(''); // Para autocomplete
  const [showNuevaDireccionModal, setShowNuevaDireccionModal] = useState(false);
  const [nuevaDireccion, setNuevaDireccion] = useState({
    alias: '',
    customer: '',
    City: '',
    State: '',
    codigo_Postal: '',
    address: '',
    GPS: ''
  });
  const [form, setForm] = useState({
    almacen: '',
    cliente: '',
    fecha: new Date().toISOString().slice(0, 10),
    observaciones: '',
    productos: [],
    // CAMPOS SIMPLIFICADOS PARA ORDENES DE SALIDA
    numeroOrdenCompra: '',
    // Selección de destino en dos pasos
    clienteFinal: '', // Customer seleccionado
    direccionId: ''   // ID de la ubicación específica seleccionada
  });
  const [error, setError] = useState("");
  const [skuBusqueda, setSkuBusqueda] = useState("");
  const [ordenId, setOrdenId] = useState('SAL-' + Date.now()); // Simulación de identificador único
  // NUEVO: Referencia externa
  const [referencia, setReferencia] = useState("");
  // NUEVO: Notificación toast
  const [toast, setToast] = useState({ show: false, type: '', message: '' });
  // NUEVO: Estado para mostrar/ocultar el diálogo de carga
  const [showExcelDialog, setShowExcelDialog] = useState(false);
  const [userWarehouses, setUserWarehouses] = useState([]);
  const [pdfReady, setPdfReady] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [ordenGuardada, setOrdenGuardada] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerSearch, setDrawerSearch] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    getWmsAlmacenes().then(setAlmacenes);
    getWmsClientes().then(setClientes);
    getWmsProductos().then(setProductos);
    getUbicaciones().then(setUbicaciones);
    // Obtener almacenes asignados al usuario
    const userId = localStorage.getItem('userId');
    if (userId) {
      getWarehousesByUser(userId).then(setUserWarehouses).catch(() => setUserWarehouses([]));
    }
  }, []);

  // Procesar ubicaciones para crear lista de clientes únicos
  useEffect(() => {
    if (ubicaciones.length > 0) {
      // Crear lista única de clientes (customers)
      const clientesUnicos = [...new Set(ubicaciones.map(u => u.customer))].filter(Boolean);
      setClientesFinales(clientesUnicos);
    }
  }, [ubicaciones]);

  // Filtrar direcciones cuando se selecciona un cliente
  useEffect(() => {
    if (form.clienteFinal && ubicaciones.length > 0) {
      const direcciones = ubicaciones.filter(u => u.customer === form.clienteFinal);
      setDireccionesCliente(direcciones);
    } else {
      setDireccionesCliente([]);
    }
  }, [form.clienteFinal, ubicaciones]);

  // Preseleccionar almacén si solo tiene uno y no es admin
  useEffect(() => {
    if (
      userRole !== 'admin' &&
      userWarehouses.length === 1 &&
      almacenes.length > 0 &&
      !form.almacen
    ) {
      setForm(f => ({ ...f, almacen: userWarehouses[0] }));
    }
  }, [userRole, userWarehouses, almacenes, form.almacen]);

  // NUEVO: Determinar si el producto requiere lote, caducidad, serie
  const requiereLote = (prod) => prod.requiere_lote;
  const requiereCaducidad = (prod) => prod.requiere_caducidad;
  const requiereSerie = (prod) => prod.requiere_serie;

  // NUEVO: Escaneo de código de barras (simulado con input)
  const handleBarcodeScan = (e) => {
    if (e.key === 'Enter') {
      buscarPorSku();
    }
  };

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Buscar producto por SKU y agregarlo como fila editable
  const buscarPorSku = () => {
    const prod = productos.find((p) => p.codigo_producto === skuBusqueda.trim());
    if (!prod) {
      setError("SKU no encontrado");
      setToast({ show: true, type: 'error', message: 'SKU no encontrado' });
      return;
    }
    // Eliminar la validación de SKU duplicado para permitir el mismo producto varias veces
    /*
    if (form.productos.some((p) => p.sku === prod.codigo_producto)) {
      setError("El producto ya está en la lista");
      setToast({ show: true, type: 'error', message: 'El producto ya está en la lista' });
      return;
    }
    */
    setForm({
      ...form,
      productos: [
        ...form.productos,
        {
          producto: prod.id,
          sku: prod.codigo_producto,
          descripcion: prod.descripcion,
          unidad: prod.unidad_medida,
          cantidad: "",
          lote: "",
          caducidad: "",
          serie: "",
          calidad: "A", // Por defecto A, no "Bueno"
          comentario: "",
          requiere_lote: prod.requiere_lote,
          requiere_caducidad: prod.requiere_caducidad,
          requiere_serie: prod.requiere_serie,
        },
      ],
    });
    setSkuBusqueda("");
    setError("");
    setToast({ show: true, type: 'success', message: 'Producto agregado' });
  };

  // Editar celda de producto en la tabla
  const handleProductoTableChange = (idx, field, value) => {
    const nuevos = form.productos.map((p, i) =>
      i === idx ? { ...p, [field]: value } : p
    );
    setForm({ ...form, productos: nuevos });
  };

  const eliminarProducto = (idx) => {
    setForm({
      ...form,
      productos: form.productos.filter((_, i) => i !== idx),
    });
    setToast({ show: true, type: 'info', message: 'Producto eliminado' });
  };

  // Generar un identificador interno para iddocumento según el tipo de orden
  const generarIdDocumento = (tipo) => {
    const prefijo = tipo === 'salida' ? 'AMES' : 'AMEI';
    return `${prefijo}-${Date.now()}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const almacenObj = almacenes.find(a => String(a.id) === String(form.almacen));
    const clienteObj = clientes.find(c => String(c.id) === String(form.cliente));
    const payload = {
      tipo: 'salida',
      almacen_id: form.almacen,
      almacen_nombre: almacenObj ? almacenObj.nombre : form.almacen,
      cliente_id: form.cliente,
      cliente: form.cliente,
      cliente_nombre: clienteObj ? clienteObj.nombre : form.cliente,
      fecha: form.fecha,
      observaciones: form.observaciones,
      iddocumento: 'AMES-' + Date.now(),
      // CAMPOS SIMPLIFICADOS PARA ORDENES DE SALIDA
      numero_orden_compra: form.numeroOrdenCompra,
      destino_id: form.direccionId, // Relación con tabla ubicaciones
      productos: form.productos.map((p) => ({
        producto_id: p.producto,
        sku: p.sku,
        descripcion: p.descripcion,
        unidad: p.unidad,
        cantidad: Number(p.cantidad),
        lote: p.lote,
        caducidad: p.caducidad || null,
        serie: p.serie,
        calidad: p.calidad,
        comentario: p.comentario,
        // Campos adicionales del XML
        vendorPartNumber: p.sku, // SKU del proveedor
        itemDescription: p.descripcion,
        lotNum: p.lote,
        orderQty: Number(p.cantidad),
        orderQtyUOM: p.unidad,
        warehouseCode: 'TX1 AM A'
      })),
    };
    try {
      await createWmsOrden(payload);
      setOrdenGuardada(payload);
      setPdfReady(true);
      setToast({ show: true, type: 'success', message: 'Orden de salida creada exitosamente' });
      setForm({
        almacen: '',
        cliente: '',
        fecha: new Date().toISOString().slice(0, 10),
        observaciones: '',
        productos: [],
        // CAMPOS SIMPLIFICADOS
        numeroOrdenCompra: '',
        clienteFinal: '',
        direccionId: ''
      });
      setReferencia("");
    } catch (err) {
      setToast({ show: true, type: 'error', message: 'Error al crear la orden' });
    }
  };

  // NUEVO: Cerrar toast automáticamente
  useEffect(() => {
    if (toast.show) {
      const t = setTimeout(() => setToast({ ...toast, show: false }), 2500);
      return () => clearTimeout(t);
    }
  }, [toast]);

  // Función para crear nueva dirección
  const handleCrearNuevaDireccion = async () => {
    try {
      const nuevaUbicacion = await createUbicacion(nuevaDireccion);
      
      // Recargar las ubicaciones
      const ubicacionesActualizadas = await getUbicaciones();
      setUbicaciones(ubicacionesActualizadas);
      
      // Actualizar el formulario con la nueva dirección
      setForm({ 
        ...form, 
        clienteFinal: nuevaDireccion.customer,
        direccionId: nuevaUbicacion.id 
      });
      setBusquedaCliente(nuevaDireccion.customer);
      
      // Limpiar el modal
      setNuevaDireccion({
        alias: '',
        customer: '',
        City: '',
        State: '',
        codigo_Postal: '',
        address: '',
        GPS: ''
      });
      setShowNuevaDireccionModal(false);
      
      setToast({ show: true, type: 'success', message: 'Nueva dirección creada exitosamente' });
    } catch (error) {
      setToast({ show: true, type: 'error', message: 'Error al crear la nueva dirección' });
    }
  };

  // Manejar carga de archivo XLSX con soporte para template mixto (cabecera + productos)
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const sheetData = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '' });
      // Buscar filas de cabecera
      let ref = '', cli = '', alm = '', obs = '';
      for (let i = 0; i < 10; i++) {
        const row = sheetData[i] || [];
        if (/referencia/i.test(row[0] || '')) ref = row[1] || '';
        if (/cliente/i.test(row[0] || '')) cli = row[1] || '';
        if (/almac[eé]n/i.test(row[0] || '')) alm = row[1] || '';
        if (/observaci/i.test(row[0] || '')) obs = row[1] || '';
      }
      // Buscar fila de títulos de productos
      let prodStart = sheetData.findIndex(r => (r[0]||'').toString().toUpperCase().trim() === 'SKU');
      if (prodStart === -1) {
        setToast({ show: true, type: 'error', message: 'No se encontró la tabla de productos (columna SKU)' });
        return;
      }
      const prodHeaders = sheetData[prodStart];
      const prodRows = sheetData.slice(prodStart + 1).filter(r => r[0]);
      let nuevos = [];
      let errores = [];
      prodRows.forEach((row, idx) => {
        const rowObj = {};
        prodHeaders.forEach((h, i) => rowObj[h] = row[i]);
        const sku = (rowObj.SKU || '').toString().trim();
        if (!sku) return;
        const prod = productos.find(p => p.codigo_producto === sku);
        if (!prod) {
          errores.push(`SKU no encontrado: ${sku} (línea ${prodStart + 2 + idx})`);
          return;
        }
        if (form.productos.some(p => p.sku === sku) || nuevos.some(p => p.sku === sku)) {
          errores.push(`SKU duplicado: ${sku} (línea ${prodStart + 2 + idx})`);
          return;
        }
        nuevos.push({
          producto: prod.id,
          sku,
          descripcion: prod.descripcion,
          unidad: prod.unidad_medida,
          cantidad: rowObj.Cantidad || '',
          lote: prod.requiere_lote ? (rowObj.Lote || '') : '',
          caducidad: prod.requiere_caducidad ? (rowObj.Caducidad || '') : '',
          serie: prod.requiere_serie ? (rowObj.Serie || '') : '',
          calidad: ['A','B','C'].includes((rowObj.Calidad||'').toUpperCase()) ? rowObj.Calidad.toUpperCase() : 'A',
          comentario: rowObj.Comentario || '',
          requiere_lote: prod.requiere_lote,
          requiere_caducidad: prod.requiere_caducidad,
          requiere_serie: prod.requiere_serie,
        });
      });
      setForm(f => ({
        ...f,
        referencia: ref || referencia,
        observaciones: obs || f.observaciones,
        cliente: cli || f.cliente,
        almacen: alm || f.almacen,
        productos: [...f.productos, ...nuevos]
      }));
      if (errores.length > 0) {
        setToast({ show: true, type: 'error', message: errores.join(' | ') });
      } else if (nuevos.length > 0) {
        setToast({ show: true, type: 'success', message: 'Productos cargados desde Excel' });
      }
    };
    reader.readAsArrayBuffer(file);
  };

  // NUEVO: Descargar template Excel con cabecera y productos
  const handleDownloadTemplate = () => {
    const ws = XLSX.utils.aoa_to_sheet([
      // Información Básica
      ['Información Básica:', ''],
      ['Cliente:', 'CLIENTE1'],
      ['Almacén:', 'ALMACEN1'],
      ['Número de Orden de Compra:', '7533160029'],
      ['Referencia externa:', 'REF-12345'],
      ['Observaciones:', 'Observación de ejemplo'],
      [],
      // Destino
      ['Destino:', ''],
      ['Cliente Final:', 'Nueva Walmart de Mexico S de RL de CV'],
      ['ID Dirección:', '1'],
      [],
      // Productos
      ['Productos:', ''],
      ['SKU', 'Cantidad', 'Lote', 'Caducidad', 'Serie', 'Calidad', 'Comentario'],
      ['SKU123', 10, 'L123', '2025-12-31', 'S123', 'A', 'Observación ejemplo'],
      ['SKU456', 5, '', '', '', 'B', 'Producto sin lote/serie'],
    ]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Orden de Salida');
    XLSX.writeFile(wb, 'template_orden_salida.xlsx');
  };

  // NUEVO: Efecto para descarga automática de PDF
  useEffect(() => {
    if (pdfUrl) {
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = `${ordenGuardada.iddocumento}.pdf`;
      link.click();
      setPdfReady(false);
      setPdfUrl(null);
      setOrdenGuardada(null);
    }
  }, [pdfUrl]);

  // Componente para producto draggable en el Drawer
  const DraggableProduct = ({ prod, onDropProduct }) => {
    const [{ isDragging }, drag] = useDrag({
      type: 'PRODUCTO',
      item: { prod },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    });
    return (
      <div
        ref={drag}
        style={{
          borderBottom: '1px solid #eee',
          padding: '8px 0',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          opacity: isDragging ? 0.5 : 1,
          cursor: 'grab',
        }}
      >
        <div>
          <div style={{ fontWeight: 500 }}>{prod.descripcion}</div>
          <div style={{ fontSize: 12, color: '#666' }}>SKU: {prod.codigo_producto} | UM: {prod.unidad_medida}</div>
          {prod.sku_cliente && (
            <div style={{ fontSize: 12, color: '#888' }}>SKU cliente: {prod.sku_cliente}</div>
          )}
        </div>
        <Button
          variant="contained"
          size="small"
          onClick={() => onDropProduct(prod)}
        >
          Agregar
        </Button>
      </div>
    );
  };

  const handleDropProduct = (prod) => {
    setForm(f => ({
      ...f,
      productos: [
        ...f.productos,
        {
          producto: prod.id,
          sku: prod.codigo_producto,
          descripcion: prod.descripcion,
          unidad: prod.unidad_medida,
          cantidad: '',
          lote: '',
          caducidad: '',
          serie: '',
          calidad: 'A',
          comentario: '',
          requiere_lote: prod.requiere_lote,
          requiere_caducidad: prod.requiere_caducidad,
          requiere_serie: prod.requiere_serie,
        },
      ],
    }));
    setToast({ show: true, type: 'success', message: 'Producto agregado desde catálogo' });
  };

  // Drop target para la tabla de productos
  const [{ isOver }, drop] = useDrop({
    accept: 'PRODUCTO',
    drop: (item) => handleDropProduct(item.prod),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });

  return (
    <DndProvider backend={HTML5Backend}>
      <div className="flex">
        {/* Sidebar drawer solo en móvil */}
        {sidebarOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-40 z-40 md:hidden"
            onClick={() => setSidebarOpen(false)}
          ></div>
        )}
        <div
          className={`fixed z-50 inset-y-0 left-0 transition-transform duration-300 md:hidden ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}
          style={{ width: '256px', minHeight: '100vh' }}
        >
          <WmsSidebar activeItem={activeItem} setActiveItem={setActiveItem} />
        </div>
        {/* Sidebar estático solo en desktop, en el flujo normal */}
        <div className="hidden md:flex">
          <WmsSidebar activeItem={activeItem} setActiveItem={setActiveItem} />
        </div>
        <div className="flex-1 bg-gray-100 min-h-screen md:p-6">
          <WmsTopbar rightContent={
            <button
              className="md:hidden p-2 ml-2"
              onClick={() => setSidebarOpen(true)}
              aria-label="Abrir menú"
              style={{ background: 'transparent', border: 'none', boxShadow: 'none' }}
            >
              <svg width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="feather feather-menu"><line x1="3" y1="12" x2="25" y2="12"/><line x1="3" y1="6" x2="25" y2="6"/><line x1="3" y1="18" x2="25" y2="18"/></svg>
            </button>
          } />
          <div className="flex bg-neutral-50 min-h-screen">
            <div className="flex-1 flex flex-col items-center px-0 sm:px-8">
              {/* El área de trabajo principal es la que se mueve con el Drawer */}
              <div
                className="w-full flex flex-col items-center mt-8 px-2 md:px-8 lg:px-16 xl:px-24 2xl:px-32"
                style={{ marginRight: drawerOpen ? 340 : 0, transition: 'margin-right 0.3s' }}
              >
                <h1 className="text-2xl font-semibold tracking-wide mb-2 text-neutral-800">Crear Orden de Salida</h1>
                <div className="mb-6 w-full flex flex-col md:flex-row md:items-center md:justify-between gap-2 border-b border-neutral-200 pb-2">
                  {/* No mostrar ID Orden de Salida hasta que se guarde */}
                  <div className="text-xs text-neutral-500 text-right">Fecha: {form.fecha}</div>
                </div>
                {/* Botón discreto para abrir diálogo de Excel */}
                <div className="w-full flex justify-end mb-2">
                  <button
                    type="button"
                    className="flex items-center gap-2 text-blue-700 hover:text-blue-900 text-sm font-medium px-2 py-1 rounded transition-colors"
                    onClick={() => setShowExcelDialog(true)}
                  >
                    <FileSpreadsheet className="w-4 h-4" />
                    Cargar desde Excel
                  </button>
                </div>
                {/* Diálogo modal para cargar/descargar Excel */}
                {showExcelDialog && (
                  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
                    <div className="bg-white rounded-lg shadow-lg p-6 min-w-[320px] max-w-xs flex flex-col gap-4 border border-neutral-200">
                      <div className="flex items-center gap-2 mb-2">
                        <UploadCloud className="w-5 h-5 text-blue-700" />
                        <span className="font-semibold text-neutral-800 text-base">Carga masiva desde Excel</span>
                      </div>
                      <button
                        type="button"
                        className="flex items-center gap-2 text-blue-700 hover:text-blue-900 text-sm font-medium px-2 py-1 rounded transition-colors border border-blue-100 bg-blue-50"
                        onClick={handleDownloadTemplate}
                      >
                        <FileSpreadsheet className="w-4 h-4" />
                        Descargar template
                      </button>
                      <label className="flex flex-col items-center gap-2 cursor-pointer text-blue-700 hover:text-blue-900 text-sm font-medium px-2 py-1 rounded transition-colors border border-blue-100 bg-blue-50">
                        <UploadCloud className="w-4 h-4" />
                        <span>Seleccionar archivo Excel</span>
                        <input type="file" accept=".xlsx,.xls" onChange={handleFileUpload} className="hidden" />
                      </label>
                      <button
                        type="button"
                        className="mt-2 text-neutral-500 hover:text-neutral-700 text-xs underline self-end"
                        onClick={() => setShowExcelDialog(false)}
                      >
                        Cerrar
                      </button>
                    </div>
                  </div>
                )}
                <form className="w-full bg-white border border-neutral-200 rounded-lg p-8 flex flex-col gap-8 shadow-none" onSubmit={handleSubmit}>
                  {/* SECCIÓN 1: INFORMACIÓN BÁSICA */}
                  <div>
                    <h2 className="font-semibold text-neutral-700 mb-4 text-base border-b border-neutral-200 pb-2">Información Básica</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <label className="block font-medium text-neutral-700 mb-1">Almacén destino</label>
                        <select
                          name="almacen"
                          value={form.almacen}
                          onChange={handleChange}
                          required
                          className="w-full border border-neutral-300 rounded-md px-3 py-2 bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-primary-500 text-neutral-800"
                          disabled={userRole !== 'admin' && userWarehouses.length === 1}
                        >
                          <option value="">Selecciona almacén</option>
                          {almacenes.map((a) => (
                            <option key={a.id} value={a.id}>{a.nombre}</option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label className="block font-medium text-neutral-700 mb-1">Cliente</label>
                        <select name="cliente" value={form.cliente} onChange={handleChange} required className="w-full border border-neutral-300 rounded-md px-3 py-2 bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-primary-500 text-neutral-800">
                          <option value="">Selecciona cliente</option>
                          {clientes.map((c) => (
                            <option key={c.id} value={c.id}>{c.nombre}</option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label className="block font-medium text-neutral-700 mb-1">Número de Orden de Compra</label>
                        <input type="text" name="numeroOrdenCompra" value={form.numeroOrdenCompra} onChange={handleChange} placeholder="7533160029" className="w-full border border-neutral-300 rounded-md px-3 py-2 bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-primary-500 text-neutral-800" />
                      </div>
                      <div className="md:col-span-2">
                        <label className="block font-medium text-neutral-700 mb-1">Referencia externa</label>
                        <input type="text" name="referencia" value={referencia} onChange={e => setReferencia(e.target.value)} placeholder="Factura, remisión, pedido, etc." className="w-full border border-neutral-300 rounded-md px-3 py-2 bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-primary-500 text-neutral-800" />
                      </div>
                      <div className="md:col-span-2">
                        <label className="block font-medium text-neutral-700 mb-1">Observaciones</label>
                        <input type="text" name="observaciones" value={form.observaciones} onChange={handleChange} className="w-full border border-neutral-300 rounded-md px-3 py-2 bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-primary-500 text-neutral-800" />
                      </div>
                    </div>
                  </div>

                  {/* SECCIÓN 2: DESTINO */}
                  <div>
                    <h2 className="font-semibold text-neutral-700 mb-4 text-base border-b border-neutral-200 pb-2">Destino</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="md:col-span-2">
                        <label className="block font-medium text-neutral-700 mb-1">Cliente Final</label>
                        <div className="flex gap-2">
                          <div className="relative flex-1">
                            <input
                              type="text"
                              placeholder="Buscar cliente..."
                              value={form.clienteFinal || busquedaCliente}
                              onChange={(e) => {
                                setBusquedaCliente(e.target.value);
                                if (!e.target.value) {
                                  setForm({ ...form, clienteFinal: '', direccionId: '' });
                                }
                              }}
                              className="w-full border border-neutral-300 rounded-md px-3 py-2 bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-primary-500 text-neutral-800 pr-10"
                            />
                            {form.clienteFinal && (
                              <button
                                type="button"
                                onClick={() => {
                                  setForm({ ...form, clienteFinal: '', direccionId: '' });
                                  setBusquedaCliente('');
                                }}
                                className="absolute right-2 top-1/2 transform -translate-y-1/2 text-neutral-400 hover:text-neutral-600"
                              >
                                ✕
                              </button>
                            )}
                          </div>
                          <button
                            type="button"
                            onClick={() => setShowNuevaDireccionModal(true)}
                            className="flex items-center justify-center w-10 h-10 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors"
                            title="Agregar nueva dirección"
                          >
                            <Plus className="w-5 h-5" />
                          </button>
                        </div>
                        {busquedaCliente && !form.clienteFinal && (
                          <div className="mt-1 max-h-40 overflow-y-auto border border-neutral-200 rounded-md bg-white">
                            {clientesFinales
                              .filter(cliente => 
                                cliente.toLowerCase().includes(busquedaCliente.toLowerCase())
                              )
                              .map((cliente, index) => (
                                <div
                                  key={index}
                                  className="px-3 py-2 hover:bg-neutral-100 cursor-pointer"
                                  onClick={() => {
                                    setForm({ ...form, clienteFinal: cliente, direccionId: '' });
                                    setBusquedaCliente('');
                                  }}
                                >
                                  {cliente}
                                </div>
                              ))}
                          </div>
                        )}
                      </div>
                      {form.clienteFinal && (
                        <div className="md:col-span-2">
                          <label className="block font-medium text-neutral-700 mb-1">Dirección</label>
                          <select 
                            name="direccionId" 
                            value={form.direccionId} 
                            onChange={handleChange} 
                            className="w-full border border-neutral-300 rounded-md px-3 py-2 bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-primary-500 text-neutral-800"
                          >
                            <option value="">Selecciona una dirección</option>
                            {direccionesCliente.map((ubicacion) => (
                              <option key={ubicacion.id} value={ubicacion.id}>
                                {ubicacion.alias} - {ubicacion.address} ({ubicacion.City}, {ubicacion.State})
                              </option>
                            ))}
                          </select>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* SECCIÓN 3: PRODUCTOS */}
                  <div>
                    <h2 className="font-semibold text-neutral-700 mb-3 text-base border-b border-neutral-200 pb-2">Productos de la orden</h2>
                    <div className="flex gap-2 items-center mb-4">
                      <input
                        type="text"
                        placeholder="Escanea o ingresa SKU del producto"
                        value={skuBusqueda}
                        onChange={(e) => setSkuBusqueda(e.target.value)}
                        onKeyDown={handleBarcodeScan}
                        className="border border-neutral-300 rounded-md px-3 py-2 bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-blue-400 text-neutral-800 w-44"
                      />
                      <button
                        type="button"
                        className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md px-4 py-2 font-semibold text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 shadow-none"
                        onClick={buscarPorSku}
                      >
                        <Search className="w-4 h-4" />
                        <span>Agregar</span>
                      </button>
                      <button
                        type="button"
                        className={`flex items-center gap-2 border border-blue-200 rounded-md px-3 py-2 font-medium text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-blue-200 shadow-none ${!form.cliente ? 'bg-gray-200 text-gray-400 cursor-not-allowed border-gray-200' : 'text-blue-700 hover:bg-blue-50'}`}
                        onClick={() => setDrawerOpen(true)}
                        disabled={!form.cliente}
                        title={!form.cliente ? 'Selecciona un cliente para ver el catálogo' : 'Abrir catálogo de productos'}
                      >
                        <Book className="w-4 h-4" />
                        <span>Catálogo{!form.cliente && ' (elige cliente)'}</span>
                      </button>
                    </div>
                    {error && <div className="text-red-600 text-sm mb-2 font-medium">{error}</div>}
                    <div
                      ref={drop}
                      className="overflow-x-auto mt-2"
                      style={{ border: isOver ? '2px dashed #1976d2' : undefined, borderRadius: 8 }}
                    >
                      <table className="min-w-full text-xs border border-neutral-200 rounded-lg bg-white">
                        <thead>
                          <tr className="bg-neutral-100 text-neutral-700 font-semibold text-xs uppercase tracking-wide">
                            <th className="px-3 py-2 text-left">SKU</th>
                            <th className="px-3 py-2 text-left">Descripción</th>
                            <th className="px-3 py-2 text-left">UM</th>
                            <th className="px-3 py-2 text-left">Cantidad</th>
                            <th className="px-3 py-2 text-left">Lote</th>
                            <th className="px-3 py-2 text-left">Caducidad</th>
                            <th className="px-3 py-2 text-left">Serie</th>
                            <th className="px-3 py-2 text-left">Calidad</th>
                            <th className="px-3 py-2 text-left">Comentario</th>
                            <th className="px-3 py-2"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {form.productos.length === 0 && (
                            <tr>
                              <td colSpan="10" className="text-center text-neutral-400 py-4">
                                No hay productos agregados
                              </td>
                            </tr>
                          )}
                          {form.productos.map((p, idx) => (
                            <tr key={idx} className={idx % 2 === 0 ? "bg-white" : "bg-neutral-50"}>
                              <td className="px-3 py-2 font-mono text-neutral-700">{p.sku}</td>
                              <td className="px-3 py-2 text-neutral-700">{p.descripcion}</td>
                              <td className="px-3 py-2 text-neutral-700">{p.unidad}</td>
                              <td className="px-3 py-2">
                                <input
                                  type="number"
                                  min="1"
                                  value={p.cantidad}
                                  onChange={e => handleProductoTableChange(idx, "cantidad", e.target.value)}
                                  className="w-20 border border-neutral-300 rounded-md px-2 py-1 bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-blue-400 text-neutral-800"
                                />
                              </td>
                              <td className="px-3 py-2">
                                <input
                                  type="text"
                                  value={p.lote}
                                  onChange={e => handleProductoTableChange(idx, "lote", e.target.value)}
                                  className="w-24 border border-neutral-300 rounded-md px-2 py-1 bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-blue-400 text-neutral-800"
                                  placeholder={p.requiere_lote ? "Obligatorio" : "Opcional"}
                                />
                              </td>
                              <td className="px-3 py-2">
                                <input
                                  type="date"
                                  value={p.caducidad}
                                  onChange={e => handleProductoTableChange(idx, "caducidad", e.target.value)}
                                  className="w-32 border border-neutral-300 rounded-md px-2 py-1 bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-blue-400 text-neutral-800"
                                  placeholder={p.requiere_caducidad ? "Obligatorio" : "Opcional"}
                                />
                              </td>
                              <td className="px-3 py-2">
                                <input
                                  type="text"
                                  value={p.serie}
                                  onChange={e => handleProductoTableChange(idx, "serie", e.target.value)}
                                  className="w-24 border border-neutral-300 rounded-md px-2 py-1 bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-blue-400 text-neutral-800"
                                  placeholder={p.requiere_serie ? "Obligatorio" : "Opcional"}
                                />
                              </td>
                              <td className="px-3 py-2">
                                <select
                                  value={p.calidad}
                                  onChange={e => handleProductoTableChange(idx, "calidad", e.target.value)}
                                  className="border border-neutral-300 rounded-md px-2 py-1 bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-blue-400 text-neutral-800"
                                >
                                  <option value="A">A</option>
                                  <option value="B">B</option>
                                  <option value="C">C</option>
                                </select>
                              </td>
                              <td className="px-3 py-2">
                                <input
                                  type="text"
                                  value={p.comentario}
                                  onChange={e => handleProductoTableChange(idx, "comentario", e.target.value)}
                                  className="w-32 border border-neutral-300 rounded-md px-2 py-1 bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-blue-400 text-neutral-800"
                                  placeholder="Observaciones"
                                />
                              </td>
                              <td className="px-3 py-2">
                                <button
                                  type="button"
                                  className="text-red-500 hover:underline font-medium"
                                  onClick={() => eliminarProducto(idx)}
                                >
                                  Eliminar
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <button type="submit" className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-3 rounded-md text-base font-semibold tracking-wide transition-colors mt-4 self-end shadow-none">Crear Orden de Salida</button>
                </form>
                {/* Toast de notificación */}
                {toast.show && (
                  <div className={`fixed bottom-8 right-8 z-50 px-6 py-3 rounded shadow-lg text-white font-semibold transition-all ${toast.type === 'success' ? 'bg-emerald-600' : toast.type === 'error' ? 'bg-red-600' : 'bg-blue-600'}`}>
                    {toast.message}
                  </div>
                )}
                {/* Botón invisible para descarga automática del PDF */}
                {ordenGuardada && (
                  <div style={{ display: 'none' }}>
                    <PDFDownloadLink
                      document={<OrdenSalidaPDF orden={ordenGuardada} logoSrc="/logoamer.ico" />}
                      fileName={`${ordenGuardada.iddocumento}.pdf`}
                    >
                      {({ url, loading }) => {
                        if (!loading && url && pdfReady && !pdfUrl) {
                          setPdfUrl(url);
                        }
                        return null;
                      }}
                    </PDFDownloadLink>
                  </div>
                )}
                <Drawer
                  variant="persistent"
                  anchor="right"
                  open={drawerOpen}
                  onClose={() => setDrawerOpen(false)}
                  sx={{
                    width: 340,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                      width: 340,
                      boxSizing: 'border-box',
                    },
                  }}
                >
                  <div style={{ width: 340, padding: 24, height: '100%', display: 'flex', flexDirection: 'column' }}>
                    <h2>Catálogo de productos</h2>
                    <input
                      type="text"
                      placeholder="Buscar por descripción o SKU..."
                      value={drawerSearch}
                      onChange={e => setDrawerSearch(e.target.value)}
                      style={{ width: '100%', margin: '12px 0 8px 0', padding: 8, borderRadius: 4, border: '1px solid #ccc', fontSize: 14 }}
                    />
                    {form.cliente ? (
                      <div style={{ flex: 1, overflowY: 'auto', marginTop: 8, minHeight: 0 }}>
                        {productos.filter(prod =>
                          String(prod.cuenta_id) === String(form.cliente) &&
                          (
                            prod.descripcion.toLowerCase().includes(drawerSearch.toLowerCase()) ||
                            prod.codigo_producto.toLowerCase().includes(drawerSearch.toLowerCase()) ||
                            (prod.sku_cliente && prod.sku_cliente.toLowerCase().includes(drawerSearch.toLowerCase()))
                          )
                        ).length === 0 && <p>No hay productos disponibles.</p>}
                        {productos.filter(prod =>
                          String(prod.cuenta_id) === String(form.cliente) &&
                          (
                            prod.descripcion.toLowerCase().includes(drawerSearch.toLowerCase()) ||
                            prod.codigo_producto.toLowerCase().includes(drawerSearch.toLowerCase()) ||
                            (prod.sku_cliente && prod.sku_cliente.toLowerCase().includes(drawerSearch.toLowerCase()))
                          )
                        ).map((prod) => (
                          <DraggableProduct key={prod.id} prod={prod} onDropProduct={handleDropProduct} />
                        ))}
                      </div>
                    ) : (
                      <p>Selecciona un cliente para ver los productos disponibles.</p>
                    )}
                    <Button onClick={() => setDrawerOpen(false)} color="secondary" style={{ marginTop: 16 }}>
                      Cerrar
                    </Button>
                  </div>
                </Drawer>
                {/* Modal para crear nueva dirección */}
                {showNuevaDireccionModal && (
                  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
                    <div className="bg-white rounded-lg shadow-lg p-6 min-w-[400px] max-w-md flex flex-col gap-4 border border-neutral-200">
                      <div className="flex items-center gap-2 mb-4">
                        <Plus className="w-5 h-5 text-blue-700" />
                        <span className="font-semibold text-neutral-800 text-base">Nueva Dirección</span>
                      </div>
                      <div className="grid grid-cols-1 gap-4">
                        <div>
                          <label className="block font-medium text-neutral-700 mb-1">Alias</label>
                          <input
                            type="text"
                            value={nuevaDireccion.alias}
                            onChange={(e) => setNuevaDireccion({...nuevaDireccion, alias: e.target.value})}
                            placeholder="Ej: Sucursal Centro"
                            className="w-full border border-neutral-300 rounded-md px-3 py-2 bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-primary-500 text-neutral-800"
                          />
                        </div>
                        <div>
                          <label className="block font-medium text-neutral-700 mb-1">Cliente Final *</label>
                          <input
                            type="text"
                            value={nuevaDireccion.customer}
                            onChange={(e) => setNuevaDireccion({...nuevaDireccion, customer: e.target.value})}
                            placeholder="Nombre del cliente"
                            required
                            className="w-full border border-neutral-300 rounded-md px-3 py-2 bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-primary-500 text-neutral-800"
                          />
                        </div>
                        <div className="grid grid-cols-2 gap-4">
                          <div>
                            <label className="block font-medium text-neutral-700 mb-1">Ciudad</label>
                            <input
                              type="text"
                              value={nuevaDireccion.City}
                              onChange={(e) => setNuevaDireccion({...nuevaDireccion, City: e.target.value})}
                              placeholder="Ciudad"
                              className="w-full border border-neutral-300 rounded-md px-3 py-2 bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-primary-500 text-neutral-800"
                            />
                          </div>
                          <div>
                            <label className="block font-medium text-neutral-700 mb-1">Estado</label>
                            <input
                              type="text"
                              value={nuevaDireccion.State}
                              onChange={(e) => setNuevaDireccion({...nuevaDireccion, State: e.target.value})}
                              placeholder="Estado"
                              className="w-full border border-neutral-300 rounded-md px-3 py-2 bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-primary-500 text-neutral-800"
                            />
                          </div>
                        </div>
                        <div>
                          <label className="block font-medium text-neutral-700 mb-1">Código Postal</label>
                          <input
                            type="number"
                            value={nuevaDireccion.codigo_Postal}
                            onChange={(e) => setNuevaDireccion({...nuevaDireccion, codigo_Postal: e.target.value})}
                            placeholder="Código postal"
                            className="w-full border border-neutral-300 rounded-md px-3 py-2 bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-primary-500 text-neutral-800"
                          />
                        </div>
                        <div>
                          <label className="block font-medium text-neutral-700 mb-1">Dirección *</label>
                          <textarea
                            value={nuevaDireccion.address}
                            onChange={(e) => setNuevaDireccion({...nuevaDireccion, address: e.target.value})}
                            placeholder="Dirección completa"
                            required
                            rows="3"
                            className="w-full border border-neutral-300 rounded-md px-3 py-2 bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-primary-500 text-neutral-800"
                          />
                        </div>
                        <div>
                          <label className="block font-medium text-neutral-700 mb-1">GPS (Opcional)</label>
                          <input
                            type="text"
                            value={nuevaDireccion.GPS}
                            onChange={(e) => setNuevaDireccion({...nuevaDireccion, GPS: e.target.value})}
                            placeholder="Coordenadas GPS"
                            className="w-full border border-neutral-300 rounded-md px-3 py-2 bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-primary-500 text-neutral-800"
                          />
                        </div>
                      </div>
                      <div className="flex gap-2 justify-end mt-4">
                        <button
                          type="button"
                          onClick={() => {
                            setShowNuevaDireccionModal(false);
                            setNuevaDireccion({
                              alias: '',
                              customer: '',
                              City: '',
                              State: '',
                              codigo_Postal: '',
                              address: '',
                              GPS: ''
                            });
                          }}
                          className="px-4 py-2 text-neutral-600 hover:text-neutral-800 font-medium"
                        >
                          Cancelar
                        </button>
                        <button
                          type="button"
                          onClick={handleCrearNuevaDireccion}
                          disabled={!nuevaDireccion.customer || !nuevaDireccion.address}
                          className="px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white rounded-md font-medium"
                        >
                          Crear Dirección
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </DndProvider>
  );
};

export default WmsOrdenSalida;
